module.exports = __webpack_public_path__ + "img/product-xr1-m.d60be1fc.jpg";